









































































































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import ViewpointSelector from '@/components/common/viewpoint-selector.vue';
import FavoriteViewer from '@/components/common/favorite-viewer.vue';
import FactorViewer from '@/components/common/factor-viewer.vue';
import SearchViewer from '@/components/common/search-viewer.vue';

let apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'ViewpointViewer',

  components: {
    ViewpointSelector,
    FavoriteViewer,
    FactorViewer,
    SearchViewer,
  },

  props: {
    sourceViewpointsProp: {
      type: Array,
      default: () => ([]),
    },
    sourceViewpointIdProp: {
      type: String,
      default: '',
    },
    compareProp: {
      type: Boolean,
      default: false,
    },
    targetViewpointsProp: {
      type: Array,
      default: () => ([]),
    },
    targetViewpointIdProp: {
      type: String,
      default: '',
    },
    teamProp: {
      type: Object,
      default: () => ({}),
    },
    authorizedActionsProp: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      sourceViewpoints: this.sourceViewpointsProp,
      sourceViewpointId: this.sourceViewpointIdProp,
      sourceError: '',
      compare: this.compareProp,
      targetViewpoints: this.targetViewpointsProp,
      targetViewpointId: this.targetViewpointIdProp,
      targetError: '',
      loading: false,
      viewerCols: 12,
      tab: null as any,
    };
  },

  created() {
    console.log('[ ViewpointViewer created() ]');
    if (this.sourceViewpointId) {
      // this.loadViewpoint(this.sourceViewpointId, 'source');
    }
    if (this.compare) {
      this.viewerCols = 6;
    }
  },

  mounted() {
  },

  watch: {
    sourceViewpointsProp(newVal, oldVal) {
      this.sourceViewpoints = newVal;
    },
    sourceViewpointIdProp(newVal, oldVal) {
      this.sourceViewpointId = newVal;
    },
    sourceViewpointId(newVal, oldVal) {
      // this.loadViewpoint(newVal, 'source');
    },
    targetViewpointsProp(newVal, oldVal) {
      this.targetViewpoints = newVal;
    },
    targetViewpointIdProp(newVal, oldVal) {
      this.targetViewpointId = newVal;
    },
    targetViewpointId(newVal, oldVal) {
      // this.loadViewpoint(newVal, 'target');
    },
    compareProp(newVal, oldVal) {
      this.compare = newVal;
      this.viewerCols = ( newVal ? 6 : 12 )
    },
    getVpGroupInstances(newVal, oldVal) {
     
    },
  },

  computed: {

     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),

    teamId(): string {
      return this.teamProp.teamId;
    },

  },

  methods: {

    isAuthorized(action: string): boolean {
      return this.authorizedActionsProp.includes(action);
    },

    sourceViewpointSelected(viewpointId: any) {
      console.log('[ viewpointSelected() > sourceViewpointId ]' + viewpointId);
      this.sourceViewpointId = viewpointId;
    },

    targetViewpointSelected(viewpointId: any) {
      console.log('[ viewpointSelected() > targetViewpointId ]' + viewpointId);
      this.targetViewpointId = viewpointId;
    },

  },


});

